import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "./navigation.css";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { AddLink, edit } from "../../../assets/images";
import { adminConfig } from "../../../utils/adminConfig";

export default class EditNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      domain: "",

      menuData: {
        menu: "",
        sub_menu: [],
        url: "",
        successor: "",
        icon: "",
      },

      sub_menu_name: "",
      sub_menu_url: "",
      logo: "",

      error: {},

      isAddSubMenu: false,
      isEditSubMenu: false,

      tv_menu: [],
      tvi_menu: [],

      edit_sub_menu_id: -1,

      edit_sub_menu_name: "",
      edit_sub_menu_url: "",

      nested_sub_menu: [],
      edit_nested_sub_menu: [],

      nested_sub_menu_name: "",
      nested_sub_menu_url: "",

      edit_nested_sub_menu_name: "",
      edit_nested_sub_menu_url: "",

      isNestedSubMenu: false,
      isEditAddedNestedSubMenu: false,

      isEditNestedSubMenu: false,
      edit_nested_sub_menu_id: -1,
    };
  }

  componentDidMount = () => {
    this.getAllMenu();
  };

  getAllMenu = () => {
    this.setState({ isLoading: true });
    axios
      .get("/get-all-menu", adminConfig())
      .then((res) => {
        this.setState({ isLoading: false });

        let { tv_menu, tvi_menu } = res.data;

        this.setState({ tv_menu, tvi_menu });
      })
      .catch((err) => {
        this.setState({ isLoading: false });

        console.error(err);
        message.error("Something went wrong");
      });
  };

  handleOnChange = (e) => {
    let { name, value } = e.target;
    let { menuData, error } = this.state;

    if (value) {
      error[name] = "";

      if (name === "url") {
        if (this.hasBlankSpace(value)) {
          error[name] = "Enter valid url";
        } else {
          error[name] = "";
        }
      }
    } else {
      error[name] = "This field required ❗";
    }

    menuData[name] = value;

    this.setState({ menuData, error });
  };

  handleImage = (e) => {
    let file = e.target.files[0];
    let validExtension = ["png"];

    let { logo } = this.state;

    if (file) {
      let extension = this.getFileExtension(file);

      if (validExtension.includes(extension)) {
        logo = file;
        this.setState({ logo });
      } else {
        message.error("The file format is not supported");
      }
    }
  };

  getFileExtension = (file) => {
    let regex = new RegExp("[^.]+$");
    return file.name.match(regex)[0].toLowerCase();
  };

  hasBlankSpace = (str) => /\s/.test(str);

  handleOnchangeSubMenu = (e) => {
    let { name, value } = e.target;
    let { error } = this.state;

    if (value) {
      error[name] = "";

      if (
        name === "sub_menu_url" ||
        name === "nested_sub_menu_url" ||
        name === "edit_sub_menu_url"
      ) {
        if (this.hasBlankSpace(value)) {
          error[name] = "Enter valid url";
        } else {
          error[name] = "";
        }
      }
    } else {
      error[name] = "This field required ❗";
    }

    this.setState({ [name]: value, error });
  };

  addSubMenu = () => {
    let { sub_menu_name, sub_menu_url, menuData, error, nested_sub_menu } =
      this.state;

    if (!sub_menu_name) {
      error.sub_menu_name = "This field required";
      this.setState({ error });
      return;
    }

    if (nested_sub_menu.length > 0) {
      error.sub_menu_url = false;
      this.setState({ error });
    }

    if (!sub_menu_url && nested_sub_menu.length === 0) {
      error.sub_menu_url = "This field required";
      this.setState({ error });
      return;
    }

    if (error.sub_menu_name || error.sub_menu_url) return;

    error.sub_menu_name = false;
    error.sub_menu_url = false;

    this.setState({ error });

    let data = {
      sub_menu: sub_menu_name,
      sub_url: nested_sub_menu.length === 0 ? sub_menu_url : "",
      nested_sub_menu,
    };

    menuData.sub_menu.push(data);

    this.setState({
      menuData,

      sub_menu_name: "",
      sub_menu_url: "",

      isAddSubMenu: false,
      nested_sub_menu: [],
    });
  };

  editMenu = (e) => {
    e.preventDefault();

    let { menuData, domain, logo } = this.state;

    if (!menuData.icon) {
      message.error("Please select menu icon");
      return;
    }

    if (menuData.sub_menu.length === 0) {
      // menuData.url = menuData.url.includes("/")
      //   ? menuData.url
      //   : "/" + menuData.url;
    } else {
      menuData.url = "";
    }

    let formData = new FormData();

    formData.append("menu", menuData.menu);
    formData.append("logo", logo);

    formData.append("icon", menuData.icon);

    menuData.sub_menu.forEach((dd, key) => {
      formData.append(`sub_menu[${key}]`, JSON.stringify(dd));
    });

    formData.append("url", menuData.url);
    formData.append("successor", menuData.successor || "");
    formData.append("domain", domain);
    formData.append("id", menuData._id);
    formData.append("head", menuData.head || "");
    formData.append("next", menuData.next || "");

    this.setState({ isLoading: true });
    axios
      .post("/edit-menu", formData, adminConfig())
      .then((res) => {
        if (res.data.status) {
          this.setState({
            domain: "",

            menuData: {
              menu: "",
              sub_menu: [],
              url: "",
              successor: "",
              icon: "",
            },

            sub_menu_name: "",
            sub_menu_url: "",
            logo: "",

            error: {},

            isAddSubMenu: false,
          });

          this.getAllMenu();
          message.success(res.data.message);
        } else {
          this.setState({ isLoading: false });
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });

        console.error(err);
        message.error("Something went wrong");
      });
  };

  addNestedSubMenu = (e) => {
    e.preventDefault();

    let {
      nested_sub_menu_name,
      nested_sub_menu_url,
      error,
      nested_sub_menu,
      edit_nested_sub_menu,
      isEditAddedNestedSubMenu,
    } = this.state;

    if (error.nested_sub_menu_name || error.nested_sub_menu_url) return;

    if (isEditAddedNestedSubMenu) {
      edit_nested_sub_menu.push({
        nested_sub_menu_name,
        nested_sub_menu_url,
      });

      this.setState({
        edit_nested_sub_menu,
        nested_sub_menu_name: "",
        nested_sub_menu_url: "",

        isNestedSubMenu: false,
        isEditAddedNestedSubMenu: false,
      });

      return;
    }

    nested_sub_menu.push({
      nested_sub_menu_name,
      nested_sub_menu_url,
    });

    this.setState({
      nested_sub_menu,
      nested_sub_menu_name: "",
      nested_sub_menu_url: "",

      isNestedSubMenu: false,
      isEditAddedNestedSubMenu: false,
    });
  };

  editnestedSubMenu = (e) => {
    e.preventDefault();

    let {
      edit_nested_sub_menu_name,
      edit_nested_sub_menu_url,
      error,
      edit_nested_sub_menu,

      edit_nested_sub_menu_id,
    } = this.state;

    if (error.edit_nested_sub_menu_name || error.edit_nested_sub_menu_url)
      return;

    edit_nested_sub_menu[edit_nested_sub_menu_id] = {
      nested_sub_menu_name: edit_nested_sub_menu_name,
      nested_sub_menu_url: edit_nested_sub_menu_url,
    };

    this.setState({
      edit_nested_sub_menu,
      edit_nested_sub_menu_name: "",
      edit_nested_sub_menu_url: "",

      edit_nested_sub_menu_id: -1,
      isEditNestedSubMenu: false,
    });
  };

  render() {
    let {
      menuData,
      error,
      tv_menu,
      tvi_menu,
      isNestedSubMenu,
      nested_sub_menu,
      edit_nested_sub_menu,
      domain,
      logo,
    } = this.state;

    return (
      <LoadingOverlay spinner active={this.state.isLoading} text="Loading...">
        {/* NESTED SUB MENU ADDED*/}
        <Modal show={isNestedSubMenu} backdrop="static" keyboard={false}>
          <Modal.Header>
            <Modal.Title>Nested Sub Menu</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={this.addNestedSubMenu}>
              <div className="menu_name cmn_name">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Submenu Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter sub menu name"
                    className="cmnfield"
                    required
                    name="nested_sub_menu_name"
                    value={this.state.nested_sub_menu_name}
                    onChange={this.handleOnchangeSubMenu}
                  />
                  <p className="text-danger">{error.nested_sub_menu_name}</p>
                </Form.Group>
              </div>
              <div className="menu_link cmn_name">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Submenu Link *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter sub menu url"
                    className="cmnfield"
                    required
                    name="nested_sub_menu_url"
                    value={this.state.nested_sub_menu_url}
                    onChange={this.handleOnchangeSubMenu}
                  />
                  <p className="text-danger">{error.nested_sub_menu_url}</p>
                </Form.Group>
              </div>
              <Button
                type="button"
                className="add_btnns"
                onClick={() => {
                  this.setState({
                    nested_sub_menu: [],
                    nested_sub_menu_name: "",
                    nested_sub_menu_url: "",

                    isNestedSubMenu: false,
                    isEditAddedNestedSubMenu: false,
                  });
                }}
              >
                Close
              </Button>
              <Button type="submit" className="add_btnns mx-5">
                Add Nested Sub Menu
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.isEditNestedSubMenu}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Nested Sub Menu</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={this.editnestedSubMenu}>
              <div className="menu_name cmn_name">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Submenu Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter sub menu name"
                    className="cmnfield"
                    required
                    name="edit_nested_sub_menu_name"
                    value={this.state.edit_nested_sub_menu_name}
                    onChange={this.handleOnchangeSubMenu}
                  />
                  <p className="text-danger">
                    {error.edit_nested_sub_menu_name}
                  </p>
                </Form.Group>
              </div>
              <div className="menu_link cmn_name">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Submenu Link *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter sub menu url"
                    className="cmnfield"
                    required
                    name="edit_nested_sub_menu_url"
                    value={this.state.edit_nested_sub_menu_url}
                    onChange={this.handleOnchangeSubMenu}
                  />
                  <p className="text-danger">
                    {error.edit_nested_sub_menu_url}
                  </p>
                </Form.Group>
              </div>
              <Button
                type="button"
                className="add_btnns"
                onClick={() => {
                  this.setState({
                    edit_nested_sub_menu_name: "",
                    edit_nested_sub_menu_url: "",

                    isEditNestedSubMenu: false,
                    edit_nested_sub_menu_id: -1,
                  });
                }}
              >
                Close
              </Button>
              <Button type="submit" className="add_btnns mx-5">
                Update
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        <div className="right_cont">
          <div className="right_banner_banner_cnt">
            <h2>Edit Menu</h2>

            <Form onSubmit={this.editMenu}>
              <div className="menu_parttts">
                <div className="predecessor_menu cmn_name">
                  <Form.Label>Domain Name *</Form.Label>
                  <Form.Control
                    name="domain"
                    onChange={(e) => {
                      this.setState({ domain: e.target.value });
                    }}
                    as="select"
                    required
                    className={`select_control ${error.domain ? "error" : ""} `}
                    value={domain}
                  >
                    <option value="">Select Domain Name</option>
                    <option value="tvi">Tipvalet Incentives</option>
                    <option value="tv">Tipvalet</option>
                  </Form.Control>
                </div>

                {domain && (
                  <>
                    <div className="predecessor_menu cmn_name">
                      <Form.Label>Edit Menu</Form.Label>
                      <Form.Control
                        as="select"
                        className="select_control"
                        required
                        onChange={(e) => {
                          let { value } = e.target;
                          if (value) {
                            let data = JSON.parse(value);
                            let sub_menu = data.sub_menu.map((res) => {
                              return JSON.parse(res);
                            });
                            data.sub_menu = sub_menu;
                            this.setState({
                              menuData: data,
                            });
                          } else {
                            this.setState({ menuData: {} });
                          }
                          this.setState({ logo: "" });
                        }}
                      >
                        <option value="">Select Menu</option>

                        {domain === "tv" &&
                          tv_menu.map((menu, key) => {
                            return (
                              <option value={JSON.stringify(menu)} key={key}>
                                {menu.menu}
                              </option>
                            );
                          })}

                        {domain === "tvi" &&
                          tvi_menu.map((menu, key) => {
                            return (
                              <option value={JSON.stringify(menu)} key={key}>
                                {menu.menu}
                              </option>
                            );
                          })}
                      </Form.Control>
                    </div>

                    <div className="menu_name cmn_name">
                      <Form.Label>Edit Menu Name</Form.Label>
                      <Form.Group controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          placeholder="Enter menu name"
                          className="cmnfield"
                          value={menuData.menu}
                          name="menu"
                          onChange={this.handleOnChange}
                          required
                        />
                      </Form.Group>
                    </div>

                    {/* LOGO */}
                    <div className="d-flex">
                      <div className="menu_logo file btn btn-lg btn-primary">
                        Add Icon
                        <input
                          type="file"
                          name="logo"
                          accept="image/png"
                          onChange={this.handleImage}
                        />
                      </div>

                      {logo ? (
                        <div className="logo_preview">
                          <img
                            src={URL.createObjectURL(logo)}
                            alt="Logo Preview"
                          />
                        </div>
                      ) : (
                        <div className="logo_preview">
                          <img src={menuData.icon} alt="Logo Preview" />
                        </div>
                      )}
                    </div>

                    {/* SUB MENU SOWING */}
                    <div className="d-flex flex-wrap">
                      {menuData.sub_menu.map((menu, key) => {
                        return (
                          <div className="show_sub_menu d-flex" key={key}>
                            <p>Name :- {menu.sub_menu}</p>
                            {menu.nested_sub_menu?.length === 0 ? (
                              <p>Link :- {menu.sub_url}</p>
                            ) : (
                              <>
                                {menu.nested_sub_menu?.map((sub, key) => {
                                  return (
                                    <div key={key} className="nested_submenu">
                                      <p>Name :- {sub.nested_sub_menu_name}</p>
                                      <p>Link :- {sub.nested_sub_menu_url}</p>
                                    </div>
                                  );
                                })}
                              </>
                            )}

                            <span
                              className="sub_menu_edit"
                              onClick={() => {
                                this.setState({
                                  edit_sub_menu_id: key,
                                  isEditSubMenu: true,
                                  edit_sub_menu_name: menu.sub_menu,
                                  edit_sub_menu_url: menu.sub_url,
                                  edit_nested_sub_menu: [
                                    ...(menu.nested_sub_menu || []),
                                  ],
                                });
                              }}
                            >
                              <img src={edit} alt="edit" />
                            </span>

                            <span
                              className="menu_cross"
                              onClick={() => {
                                menuData.sub_menu.splice(key, 1);
                                this.setState({ menuData });
                              }}
                            >
                              X
                            </span>
                          </div>
                        );
                      })}
                    </div>

                    {/* FOR EDIT */}
                    {this.state.isEditSubMenu && (
                      <div className="add_submenu_ppppaaartttsss">
                        <div className="menu_name cmn_name">
                          <Form.Group controlId="formBasicEmail">
                            <Form.Label>Submenu Name *</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter sub menu name"
                              className="cmnfield"
                              required
                              name="edit_sub_menu_name"
                              value={this.state.edit_sub_menu_name}
                              onChange={this.handleOnchangeSubMenu}
                            />
                            <p className="text-danger">
                              {error.edit_sub_menu_name}
                            </p>
                          </Form.Group>
                        </div>
                        {/*SHOW NESTED SUB MENU */}

                        <div className="d-flex flex-wrap">
                          {edit_nested_sub_menu.map((menu, key) => {
                            return (
                              <div className="show_sub_menu d-flex" key={key}>
                                <p>Name :- {menu.nested_sub_menu_name}</p>
                                <p>Link :- {menu.nested_sub_menu_url}</p>

                                <span
                                  className="sub_menu_edit"
                                  onClick={() => {
                                    this.setState({
                                      edit_nested_sub_menu_id: key,
                                      isEditNestedSubMenu: true,
                                      edit_nested_sub_menu_name:
                                        menu.nested_sub_menu_name,
                                      edit_nested_sub_menu_url:
                                        menu.nested_sub_menu_url,
                                    });
                                  }}
                                >
                                  <img src={edit} alt="edit" />
                                </span>

                                <span
                                  className="menu_cross"
                                  onClick={() => {
                                    edit_nested_sub_menu.splice(key, 1);
                                    this.setState({ edit_nested_sub_menu });
                                  }}
                                >
                                  X
                                </span>
                              </div>
                            );
                          })}
                        </div>

                        {edit_nested_sub_menu.length === 0 && (
                          <div className="menu_link cmn_name">
                            <Form.Group controlId="formBasicEmail">
                              <Form.Label>Submenu Link *</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter sub menu url"
                                className="cmnfield"
                                required
                                name="edit_sub_menu_url"
                                value={this.state.edit_sub_menu_url}
                                onChange={this.handleOnchangeSubMenu}
                              />
                              <p className="text-danger">
                                {error.edit_sub_menu_url}
                              </p>
                            </Form.Group>
                          </div>
                        )}
                        <Button
                          type="button"
                          className="add_btnns"
                          onClick={() => {
                            this.setState({
                              edit_sub_menu_name: "",
                              edit_sub_menu_url: "",
                              edit_sub_menu_id: -1,
                              edit_nested_sub_menu: [],
                              isEditSubMenu: false,
                            });
                          }}
                        >
                          Close
                        </Button>

                        <Button
                          type="button"
                          className="add_btnns mx-5"
                          onClick={() => {
                            let {
                              edit_sub_menu_name,
                              edit_sub_menu_url,
                              edit_sub_menu_id,
                            } = this.state;

                            if (!edit_sub_menu_name) {
                              error.edit_sub_menu_name = "This field required";
                              this.setState({ error });
                              return;
                            }

                            if (edit_nested_sub_menu.length > 0) {
                              error.edit_sub_menu_url = false;
                              this.setState({ error });
                            }

                            if (
                              !edit_sub_menu_url &&
                              edit_nested_sub_menu.length === 0
                            ) {
                              error.edit_sub_menu_url = "This field required";
                              this.setState({ error });
                              return;
                            }

                            if (
                              error.edit_sub_menu_name ||
                              error.edit_sub_menu_url
                            )
                              return;

                            error.edit_sub_menu_name = false;
                            error.edit_sub_menu_url = false;

                            this.setState({ error });

                            let data = {
                              sub_menu: edit_sub_menu_name,
                              sub_url:
                                edit_nested_sub_menu.length === 0
                                  ? edit_sub_menu_url
                                  : "",
                              nested_sub_menu: edit_nested_sub_menu,
                            };

                            menuData.sub_menu[edit_sub_menu_id] = data;

                            this.setState({
                              menuData,

                              edit_sub_menu_name: "",
                              edit_sub_menu_url: "",
                              edit_sub_menu_id: -1,

                              isEditSubMenu: false,
                              edit_nested_sub_menu: [],
                            });
                          }}
                        >
                          Update
                        </Button>

                        <Button
                          onClick={() => {
                            this.setState({
                              isNestedSubMenu: true,
                              isEditAddedNestedSubMenu: true,
                            });
                          }}
                          type="button"
                          className="add_btnns"
                        >
                          Add Nested Sub Menu
                        </Button>
                      </div>
                    )}

                    {!this.state.isAddSubMenu && (
                      <div className="add_sub_menu">
                        <button
                          type="button"
                          className="add_sub"
                          onClick={() => {
                            this.setState({ isAddSubMenu: true });
                          }}
                        >
                          <span>
                            <img src={AddLink} alt="Sub Menu" />
                          </span>
                          Add Sub Menu
                        </button>
                      </div>
                    )}

                    {this.state.isAddSubMenu && (
                      <div className="add_submenu_ppppaaartttsss">
                        <div className="menu_name cmn_name">
                          <Form.Group controlId="formBasicEmail">
                            <Form.Label>Submenu Name *</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter sub menu name"
                              className="cmnfield"
                              required
                              name="sub_menu_name"
                              value={this.state.sub_menu_name}
                              onChange={this.handleOnchangeSubMenu}
                            />
                            <p className="text-danger">{error.sub_menu_name}</p>
                          </Form.Group>
                        </div>

                        {/* NESTED SUB MENU */}

                        <div className="d-flex flex-wrap">
                          {nested_sub_menu?.map((menu, key) => {
                            return (
                              <div className="show_sub_menu d-flex" key={key}>
                                <p>Name :- {menu.nested_sub_menu_name}</p>
                                <p>Link :- {menu.nested_sub_menu_url}</p>

                                <span
                                  className="menu_cross"
                                  onClick={() => {
                                    nested_sub_menu.splice(key, 1);
                                    this.setState({ nested_sub_menu });
                                  }}
                                >
                                  X
                                </span>
                              </div>
                            );
                          })}
                        </div>

                        {nested_sub_menu.length === 0 && (
                          <div className="menu_link cmn_name">
                            <Form.Group controlId="formBasicEmail">
                              <Form.Label>Submenu Link *</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter sub menu url"
                                className="cmnfield"
                                required
                                name="sub_menu_url"
                                value={this.state.sub_menu_url}
                                onChange={this.handleOnchangeSubMenu}
                              />
                              <p className="text-danger">
                                {error.sub_menu_url}
                              </p>
                            </Form.Group>
                          </div>
                        )}

                        <Button
                          type="button"
                          className="add_btnns"
                          onClick={this.addSubMenu}
                        >
                          Done
                        </Button>
                        <Button
                          onClick={() => {
                            this.setState({ isNestedSubMenu: true });
                          }}
                          type="button"
                          className="add_btnns mx-5"
                        >
                          Add Nested Sub Menu
                        </Button>
                        <Button
                          type="button"
                          className="add_btnns"
                          onClick={() => {
                            error.sub_menu_name = false;
                            error.sub_menu_url = false;

                            this.setState({
                              sub_menu_name: "",
                              sub_menu_url: "",

                              isAddSubMenu: false,
                              nested_sub_menu: [],
                              error,
                            });
                          }}
                        >
                          Close
                        </Button>
                      </div>
                    )}

                    {menuData.sub_menu.length === 0 && (
                      <div className="menu_link cmn_name">
                        <Form.Label>Edit Menu Link</Form.Label>

                        <Form.Group controlId="formBasicEmail">
                          <Form.Control
                            type="text"
                            placeholder="Enter menu Link"
                            name="url"
                            required
                            className={`cmnfield ${error.url ? "error" : ""}`}
                            value={menuData.url}
                            onChange={this.handleOnChange}
                          />
                          <p className="text-danger">{error.url}</p>
                        </Form.Group>
                      </div>
                    )}

                    {/* FOR Tipvalet(tv) */}

                    <div className="predecessor_menu cmn_name">
                      <Form.Label>Successor Menu</Form.Label>
                      <Form.Control
                        name="successor"
                        as="select"
                        className="select_control"
                        onChange={this.handleOnChange}
                      >
                        <option value="">Select Successor</option>

                        {domain === "tv" &&
                          tv_menu.map((menu, key) => {
                            return (
                              <option
                                value={menu._id}
                                key={key}
                                disabled={
                                  menu._id === menuData._id ||
                                  menu.next === menuData._id
                                }
                              >
                                {menu.menu}
                              </option>
                            );
                          })}

                        {domain === "tvi" &&
                          tvi_menu.map((menu, key) => {
                            return (
                              <option
                                value={menu._id}
                                key={key}
                                disabled={menu._id === menuData._id}
                              >
                                {menu.menu}
                              </option>
                            );
                          })}
                      </Form.Control>
                    </div>
                  </>
                )}

                <div className="add_button cmn_name">
                  <button type="submit" className="add_btnns">
                    Update
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
